"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedProdRegion = exports.SupportedDevRegion = exports.Edition = void 0;
exports.mapToLegacySnowflakeRegionName = mapToLegacySnowflakeRegionName;
// Note: these are case sensitive in Salesforce, do not change
var Edition;
(function (Edition) {
    Edition["STANDARD"] = "Standard";
    Edition["ENTERPRISE"] = "Enterprise";
    Edition["BUSINESS_CRITICAL"] = "Business Critical";
})(Edition || (exports.Edition = Edition = {}));
function mapToLegacySnowflakeRegionName(snowhouseRegionValue) {
    // See GROW-2149 for why we need this
    switch (snowhouseRegionValue) {
        case 'azwestus2':
            return 'westus2';
        case 'useast2':
            return 'east-us-2';
        case 'europewest':
            return 'west-europe';
        case 'australia-east':
            return 'australiaeast';
        case 'switzerlandnorth':
            return 'switzerlandn';
        default:
            return snowhouseRegionValue;
    }
}
exports.SupportedDevRegion = ['preprod8', 'reg'];
exports.SupportedProdRegion = [
    'af-south-1',
    'ap-northeast-1',
    'australia-southeast2',
    'ap-northeast-2',
    'ap-northeast-3',
    'ap-south-1',
    'ap-southeast-1',
    'ap-southeast-2',
    'ap-southeast-3',
    'ap-southeast-5',
    'ap-southeast-6',
    'ap-southeast-7',
    'australiaeast',
    'ca-central-1',
    'canadacentral',
    'centralindia',
    'centralus',
    'east-us-2',
    'eastasia',
    'eastus',
    'eu-central-1',
    'eu-central-2',
    'eu-north-1',
    'eu-west-1',
    'eu-west-2',
    'eu-west-3',
    'europe-west2',
    'europe-west3',
    'europe-west4',
    'japaneast',
    'koreacentral',
    'northeurope',
    'sa-east-1',
    'southcentralus',
    'southeastasia',
    'switzerlandn',
    'uaenorth',
    'uksouth',
    'us-central1',
    'us-east4',
    'us-east-1',
    'us-east-2',
    'us-west-2',
    'west-europe',
    'westus2',
    'me-central-1',
    'me-central2',
    'mexicocentral',
    'swedencentral',
];
//# sourceMappingURL=deploymentMetadata.js.map